/* hooks/useModelPermission.ts */
import { useEffect, useState } from 'react';
import { fetchModelPermissionsByFilter, ModelPermission as MP } from '../services/modelPermissionsService';
import { useAuth } from '../context/AuthContext';
import { isUserSuperAdmin } from '../utils/userTier';

export function useModelPermission(
    modelName: string,
    userLevelId: number
): MP | null {
    const { user } = useAuth();
    const isSuper = isUserSuperAdmin(user);

    const [perm, setPerm] = useState<MP | null>(() => {
        if (isSuper) {
            return {
                id: 0,
                user_level: userLevelId || 1,
                model_name: modelName,
                can_create: true,
                can_read: true,
                can_update: true,
                can_delete: true,
            };
        }
        return null;
    });

    useEffect(() => {
        if (isSuper) {
            setPerm({
                id: 0,
                user_level: userLevelId || 1,
                model_name: modelName,
                can_create: true,
                can_read: true,
                can_update: true,
                can_delete: true,
            });
            return;
        }

        if (!userLevelId) return;

        fetchModelPermissionsByFilter({ user_level: userLevelId, model_name: modelName })
            .then((arr) => setPerm(arr.length > 0 ? arr[0] : {
                id: 0,
                user_level: userLevelId,
                model_name: modelName,
                can_create: false,
                can_read: false,
                can_update: false,
                can_delete: false,
            }))
            .catch(() => setPerm({
                id: 0,
                user_level: userLevelId,
                model_name: modelName,
                can_create: false,
                can_read: false,
                can_update: false,
                can_delete: false,
            }));
    }, [modelName, userLevelId, isSuper]);

    return perm;
}

